import React, { useState, useEffect, useRef, useContext } from 'react';
// import Logo from '../Assets/images/logo.png';
import Logo from '../Assets/images/pranaam-365-logo.png';
import Notification from '../Assets/images/notification.png';
import ProfileImg from '../Assets/images/settings.png';
// import Popup from '../Components/popup';
import close from '../Assets/images/close.png';
import Search from '../Assets/images/search.png';
import Hospital from '../Assets/images/hospital.png';
import { OrganizationContext } from '../../Services/OrganizationContext';
import authService from '../../Services/authService';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Icon from '../Assets/menuicons/Icon';
import { useLocation } from 'react-router-dom';


const DashMenu = () => {
  const [isPopupVisible, setPopupVisible] = useState(false);
  const dropdownRef = useRef(null);
  const profileRef = useRef(null);
  const sidebarRef = useRef(null);
  const [organizations, setOrganizations] = useState([]);
  const { organization, setOrganization } = useContext(OrganizationContext);
  const navigate = useNavigate();
  const location = useLocation();

  // Get the current URL path
  const currentPath = location.pathname;

  // Split the path into segments
  const pathSegments = currentPath.split('/').filter(segment => segment);

  // Get the second segment (index 1)
  const secondSegment = pathSegments[1] || 'No second segment';


  useEffect(() => {
    loadOrganizations();
    const storedOrganization = authService.getAdminOrganizationID();
    if (storedOrganization) {
      setOrganization(storedOrganization);
    }
  }, []);


  const loadOrganizations = () => {
    const token = authService.getCurrentadmin().token; // Retrieve the token for authorization

    if (authService.getCurrentadmin().UserInfo.role_id !== 2) {
      // Construct the URL with the organization_id as a query parameter
      const url = new URL(authService.getApiUrl() + 'organizations/multiple');
      //url.searchParams.append('organization_id', organization); // Append the organization_id as a query parameter

      fetch(url, {
        method: 'POST', // Set method to GET
        body: JSON.stringify({
          ids: authService.getCurrentadmin().UserInfo.organizations
            ? authService.getCurrentadmin().UserInfo.organizations.replace(/[\[\]"]/g, '').split(',').map(Number)
            : [],
        }),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${token}`, // Include Authorization header with Bearer token if required
        },
      })
        .then((res) => {
          if (res.status === 401) {
            // If status is 401, redirect to the login page
            //alert("Unauthorized! Redirecting to login page.");
            authService.logout();
            window.location.href = "/admin"; // Replace with your login route
          } else {
            return res.json(); // Proceed with parsing JSON if the response is okay
          }
        })
        .then((result) => {
          setOrganizations(result.data); // Set the category data in state
        })
        .catch((err) => {
          console.log(err.message); // Handle any errors
        });

    } else {

      // Construct the URL with the organization_id as a query parameter
      const url = new URL(authService.getApiUrl() + 'organizations');
      //url.searchParams.append('organization_id', organization); // Append the organization_id as a query parameter

      fetch(url, {
        method: 'GET', // Set method to GET
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${token}`, // Include Authorization header with Bearer token if required
        },
      })
        .then((res) => {
          if (res.status === 401) {
            // If status is 401, redirect to the login page
            //alert("Unauthorized! Redirecting to login page.");
            authService.logout();
            window.location.href = "/admin"; // Replace with your login route
          } else {
            return res.json(); // Proceed with parsing JSON if the response is okay
          }
        })
        .then((result) => {
          setOrganizations(result.data); // Set the category data in state
        })
        .catch((err) => {
          console.log(err.message); // Handle any errors
        });
    }

  };

  const handleDropdownClick = () => {
    setPopupVisible(true);
  };

  const handleClosePopup = () => {
    setPopupVisible(false);
  };

  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [isActive, setActive] = useState(false);

  const handleNotifyClick = () => {
    setDropdownVisible(!isDropdownVisible);
    setActive(!isActive);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownVisible(false);
      setActive(false);
    }
    if (profileRef.current && !profileRef.current.contains(event.target)) {
      setSetVisible(false);
      setDctive(false);
    }
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      // Handle clicks outside the sidebar if needed
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [isSetVisible, setSetVisible] = useState(false);
  const [areDctive, setDctive] = useState(false);
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const handleProfileClick = () => {
    setSetVisible(!isSetVisible);
    setDctive(!areDctive);
  };

  const handleToggleMenuClick = () => {
    document.body.classList.toggle('sidebar-open');
    setSidebarOpen(!isSidebarOpen);
  };

  const [activeIndex, setActiveIndex] = useState(null);
  const handleDropdown = (index) => {
    setActiveIndex(prevIndex => (prevIndex === index ? null : index));
  };

  const menuItems = [
    'Item 1',
  ];

  const closeModal = () => {
    setPopupVisible(false);
  }

  const handleOrganizationChange = (organizationId) => {
    //const organizationId = e.target.value;
    authService.setAdminorganizationID(organizationId);
    setOrganization(organizationId);
    setPopupVisible(false);
  };

  const handleLogout = () => {
    authService.logout();  // Clear the session from auth service
    sessionStorage.clear();  // Clear sessionStorage (including user data)
    localStorage.clear();    // Clear localStorage if needed
    window.location.href = "/admin";  // Redirect to login page or another route
  }

  return (
    <>
      <nav>
        <div className='navbar ce-header'>
          <div className='header-container'>
            <div className='flex-cont'>
              <div className='logo-menu'>
                <div className={`toogle-menu ${isSidebarOpen ? 'is-active' : ''}`} id='Toogle-menu' onClick={handleToggleMenuClick}>
                  <span>toggle menu</span>
                </div>
                <div className='logo-img'>
                  <img src={Logo} alt='site-logo' title='site-logo' />
                </div>
                {authService.getCurrentadmin() && (authService.getCurrentadmin().UserInfo.role_id === 2 ||
                  authService.getCurrentadmin().UserInfo.organizations ? authService.getCurrentadmin().UserInfo.organizations.split(',').length : 0 > 1) && (
                    <div className='dropdown' onClick={handleDropdownClick}>
                      <input type='hidden' name='selected_hospital_id' id='selected_hospital_id' value='' />
                      <span className='branch-dropdown'>

                        {/* <input  placeholder='Select branch'/> */}
                        <select
                          disabled
                          onChange={handleOrganizationChange}
                          value={organization ?? "0"}
                        >
                          <option value="0" key="default">--Select--</option>
                          {organizations.map((item) => (
                            <option value={item.id} key={item.id}>{item.name}</option>
                          ))}
                        </select>
                        <span className='abs-btn' onClick={handleDropdownClick}></span>
                      </span>
                    </div>
                  )}

              </div>
              <div className='notify'>
                {/* <div ref={dropdownRef} className={`notify-cont ${isActive ? 'active' : ''}`} onClick={handleNotifyClick}>
                  <span><img src={Notification} alt='notification' title='notification' /></span>
                  <div className='notify-dropdown' style={{ display: isDropdownVisible ? 'block' : 'none' }}>
                    <ul>
                      <li>This is a notification</li>
                      <li>This is a notification</li>
                      <li>This is a notification</li>
                    </ul>
                  </div>
                </div> */}
                <div ref={profileRef} className={`profile-cont ${areDctive ? 'active' : ''}`} onClick={handleProfileClick}>
                  <div className='profile-img'>
                    <img src={ProfileImg} alt='profile-img' title='profile-img' />
                  </div>
                  <div className='profile-dropdown' style={{ display: isSetVisible ? 'block' : 'none' }}>
                    <ul>
                      {/* <li>Edit Profile</li> */}
                      <li onClick={handleLogout}>Logout</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      {isPopupVisible &&
        <div className="modal">
          <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className='top-heading'>
                <div className='popup-headings'>
                  <h3>Select Outlet</h3>
                  <button type="button" className="close" onClick={closeModal}>
                    <img src={close} alt="close" title="close" />
                  </button>
                </div>
                <div className='p-2'>
                  <div className='search-bar'>
                    <span className='search-icon-admin'>
                      <img src={Search} alt='search' title='search' />
                    </span>
                    <input type='text' placeholder='Search' className='search-Input' id='header_text' />
                    <span className='clear'>Clear</span>
                  </div>
                </div>
              </div>
              <div className='hospitals'>
                <div className='All-cont'>
                  <div className='hospital-detail'>
                    <img src={Hospital} alt='hospital' title='hospital' />
                    <h3>All Hospitals</h3>
                  </div>
                </div>
                <div className='all-hospitals'>
                  {organizations.map((org, index) => (
                    <div className='hospital-cont' key={index} onClick={() => handleOrganizationChange(org.id)}>
                      <div className='hospital-detail'>
                        <img src={Hospital} alt='hospital' title='hospital' />
                        <h3>{org.name || "Pranaam"}</h3>
                      </div>
                      <div className='hsp-id'>
                        <p>[ id : {org.id} ]</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop" onClick={closeModal}></div>
        </div>
        // <Popup showModal={isPopupVisible} closeModal={handleClosePopup} organizations={organizations}/>
      }






      <div className='sidebar sidebar-menu' ref={sidebarRef}>
        <div className='scroll-content'>
          <ul>
            {authService.getCurrentadmin() && authService.getCurrentadmin().sidemenu ? (
              authService.getCurrentadmin().sidemenu.map((item, index) => {

                // const link = (item.menu.sub_menu && item.menu.sub_menu.length > 0 && item.menu.sub_menu[0].path) 
                //               ? item.menu.path+'/'+item.menu.sub_menu[0].path : item.menu.path;
                const link = (item.menu.name === "Dashboard")
                  ? item.menu.path
                  : (item.menu.sub_menu && item.menu.sub_menu.length > 0 && item.menu.sub_menu[0].path)
                    ? item.menu.path + '/' + item.menu.sub_menu[0].path
                    : item.menu.path;

                return (
                 <React.Fragment key={item.menu.id || item.menu.name || index}>
                    {item.menu.path === 'organizations' && (
                      <span className='menu-heading'>
                        <div className="profile-img">
                          <img src={ProfileImg} alt="profile-img" title="profile-img"></img>
                        </div>
                        Master Setup
                      </span>
                    )}

                    {/* {item.menu.sub_menu && item.menu.sub_menu.length > 0 ? (
                    <li 
                      key={index}
                      className={`sidebar-dropdown table-icon ${activeIndex === index ? 'dropmenu' : ''}`}
                      onClick={() => handleDropdown(index)}
                    >
                      <a id='left_dashboard'>
                        <Icon name={item.menu.icon} />
                        <span className='menu-title'>{item.menu.name}</span>
                      </a>
                      <ul className='sidebar-submenu' style={{display: 'none'}}>
                        {item.menu.sub_menu.map((subItem, subIndex) => (
                          <li key={subIndex}>
                            <Link to="/admin/orders">
                              <span className='menu-title'>{subItem.name}</span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                    ) : ( */}
                    <li className={`dashboard ${secondSegment === item.menu.path ? 'active' : ''}`} >
                      <a id='left_dashboard' href={'/admin/' + link}>
                        <Icon name={item.menu.icon} />
                        <span className='menu-title'>{item.menu.name}</span>
                      </a>

                    </li>
                    {/* )} */}
                  </React.Fragment>
                );
              })
            ) : (
              <li></li>
            )}



          </ul>

        </div>
      </div>


      {/* footer */}
      <div className='footer-cont'>



        <div className="flex-cont">
          <div className="veegam-cont">
            <span>Pranaam365 © 2025. All Rights Reserved.</span>
          </div>
          <div className="footer-menu">
            <ul className="footer-menu-cont">
              <li><Link to="/">Terms & Conditions</Link></li>
              <li><Link to="/">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
      </div>

    </>
  );
};

export default DashMenu;
